export const SESSION_TIMEOUT_MODAL_TITLE = 'Session Expiring Soon';

export const buildSessionTimeoutModalMessage = (secondsRemaining: number): string =>
  `You are being logged out due to inactivity.\nYour session will expire in ${secondsRemaining} second${
    secondsRemaining === 1 ? '' : 's'
  }.`;
